import { AdministrationApi, PocApi } from '../../../apis';
import { AppForSa } from '../../../types/administrator';
import { TokenStatus } from '../../../types/provision';
import { Action, O365AuditLogBannerStatus } from './type';

export async function getO365AuditLogBannerStatus(
  orgId: string
): Promise<O365AuditLogBannerStatus> {
  const tokens: {
    app: AppForSa | 'o365AuditLog' | 'socManagement' | 'soc';
    tokenStatus: TokenStatus;
    tokenTypes: number[];
  }[] = (await AdministrationApi.apiGetTokenStatus(orgId)).data as any;

  const exchangeOnlineToken = tokens.find(
    (token) =>
      token.app === AppForSa.Exchange &&
      token.tokenStatus === TokenStatus.Created
  );

  // no exchange service provisioned, not show provision banner
  if (!exchangeOnlineToken) {
    return {
      action: Action.Provision,
      show: false,
    };
  }

  // exchange online in poc mode, not show provision banner
  const isPoc = await PocApi.apiCheckIsPoc(orgId);
  if (isPoc) {
    return {
      action: Action.Provision,
      show: false,
    };
  }

  const o365AuditLogToken = tokens.find(
    (token) => token.app === 'o365AuditLog'
  );

  // has provisioned, 36、37 both exist, but maybe invalid
  if (o365AuditLogToken && o365AuditLogToken.tokenTypes.length === 2) {
    if (o365AuditLogToken.tokenStatus === TokenStatus.Failure) {
      // both tokens exist and someone is invalid, only this case show reAuth banner
      return {
        action: Action.ReAuth,
        show: true,
      };
    } else {
      // 36、37 are all valid, not show reAuth banner
      return {
        action: Action.ReAuth,
        show: false,
      };
    }
  }

  const socTokens = tokens.filter(
    (token) =>
      ['soc', 'socManagement'].includes(token.app) &&
      token.tokenStatus === TokenStatus.Created
  );

  // the two soc token are ready and valid, no need to create 36、37 token
  // not show provision banner
  if (socTokens.length === 2) {
    return {
      action: Action.Provision,
      show: false,
    };
  }

  // not provision or missing a token, show provision banner
  if (!o365AuditLogToken || o365AuditLogToken.tokenTypes.length < 2) {
    return {
      action: Action.Provision,
      show: true,
    };
  }

  // every is ready
  return {
    action: Action.ReAuth,
    show: false,
  };
}
